import React from "react";

const getSpeakerLabel = (rec, index) => {
  const match = rec.speaker_labels?.find(l => l.speaker_index === index);
  return match ? match.custom_label : `Speaker ${index + 1}`;
};

const TranscriptLine = ({ match, rec, updateSpeakerLabel }) => {
  const speakerIndex = parseInt(match[1].split("_")[1]) || 0;
  return (
    <div className="transcript-line">
      <input
        className="speaker-label-input"
        type="text"
        defaultValue={getSpeakerLabel(rec, speakerIndex)}
        onBlur={e => {
          updateSpeakerLabel(rec.recording_id, speakerIndex, e.target.value);
        }}
      />
      <span
        className="timestamp"
        onClick={() => {
          const audio = document.getElementById(`audio-${rec.id}`);
          if (audio) {
            audio.currentTime = parseFloat(match[2]);
            audio.play();
          }
        }}
      >
        {match[2]}–{match[3]}
      </span>
      <div className="timestamp-divider" />
      <span>{match[4].trim()}</span>
    </div>
  );
};

export default TranscriptLine;
